import {
  array,
  boolean,
  check,
  custom,
  integer,
  maxLength,
  maxValue,
  minLength,
  minValue,
  nonOptional,
  number,
  object,
  optional,
  pipe,
  string,
  transform,
  union
} from 'valibot';

export const createCourseFormSchema = () =>
  object({
    title: pipe(
      nonOptional(string(), 'courseForm.validation.courseTitleIsRequired'),
      minLength(1, 'courseForm.validation.courseTitleIsRequired'),
      maxLength(200, 'courseForm.validation.courseTitleCannotExceed200Characters')
    ),
    description: pipe(
      optional(string()),
      check(
        value => !value || value.length <= 1000,
        'courseForm.validation.descriptionCannotExceed1000Characters'
      )
    ),
    timezone: pipe(
      nonOptional(string(), 'courseForm.validation.timezoneRequired'),
      minLength(1, 'courseForm.validation.timezoneRequired')
    ),
    maxParticipants: pipe(
      nonOptional(
        pipe(
          number(),
          integer('courseForm.validation.maxParticipantsMustBeWholeNumber'),
          minValue(1, 'courseForm.validation.mustBeAtLeast1Participant'),
          maxValue(1000, 'courseForm.validation.cannotExceed1000Participants')
        ),
        'courseForm.validation.maxParticipantsRequired'
      )
    ),
    expectedParticipants: pipe(
      optional(union([number(), string()])),
      transform(v => {
        if (v === '' || v === null || v === undefined) {
          return undefined;
        }
        return typeof v === 'number' ? v : Number(v);
      }),
      optional(
        pipe(
          number(),
          integer('courseForm.validation.expectedParticipantsMustBeWholeNumber'),
          minValue(0, 'courseForm.validation.cannotBeNegative'),
          maxValue(1000, 'courseForm.validation.cannotExceed1000Participants')
        )
      )
    ),
    daDataCenterIds: optional(array(string())),
    daOrganizationId: pipe(
      nonOptional(number(), 'courseForm.validation.organizationRequired'),
      integer('courseForm.validation.organizationIdMustBeValidNumber')
    ),
    wantToBeCoordinator: optional(boolean()),
    isDemo: optional(boolean()),
    trainerUserId: pipe(
      optional(union([string(), custom(v => v === null, 'courseForm.validation.expectedString')])),
      transform(v => v ?? undefined),
      optional(string())
    ),
    trainerEmail: pipe(
      optional(union([string(), custom(v => v === null, 'courseForm.validation.expectedString')])),
      transform(v => v ?? undefined),
      optional(string())
    ),
    pendingTrainerInviteEmails: optional(array(string())),
    courseDates: pipe(
      nonOptional(
        array(
          object({
            id: string(),
            startDate: string(),
            endDate: string()
          })
        ),
        'courseForm.validation.courseDatesRequired'
      ),
      check(value => value.length > 0, 'courseForm.validation.atLeastOneCourseDateRequired'),
      check(
        value => value.length <= 50,
        'courseForm.validation.cannotHaveMoreThan50CourseSessions'
      ),
      custom(value => {
        if (!Array.isArray(value) || value.length === 0) {
          return false;
        }

        for (const date of value) {
          if (!date || typeof date !== 'object') {
            return false;
          }
          if (!date.id || typeof date.id !== 'string') {
            return false;
          }
          if (!date.startDate || typeof date.startDate !== 'string') {
            return false;
          }
          if (!date.endDate || typeof date.endDate !== 'string') {
            return false;
          }
        }

        return true;
      }, 'courseForm.validation.invalidCourseDateStructure')
    )
  });
